const main= (to,domain)=>{
 to.matched.forEach(i => {
  if ( i.meta && i.meta.title ){ document.title=i.meta.title +" | "+ domain; }
 });
};
export default main;